import api from './api'

export interface Review {
  id: string
  rating: number
  comment: string | null
  reply_text: string | null
  replied_at: string | null
  created_at: string
  shipper_id?: string
  shipper_name: string
  reviewer_name?: string | null
  order_id?: string
}

export interface RatingSummary {
  total: number
  average: number
  breakdown: Record<string, number>
  completed_orders?: number
}

export interface ReviewListResponse {
  items: Review[]
  total: number
  page: number
  pageSize: number
}

export async function submitOrderReview(orderId: string, rating: number, comment?: string) {
  const res = await api.post<{ review: Review }>(`/shipper/orders/${orderId}/review`, { rating, comment })
  return res.data.review
}

export async function replyToReview(reviewId: string, reply: string) {
  const res = await api.post<{ review: Review }>(`/freight-forwarder/reviews/${reviewId}/reply`, { reply })
  return res.data.review
}

export async function fetchMyFreightForwarderReviews(): Promise<Review[]> {
  const res = await api.get<{ items: Review[] }>('/freight-forwarder/reviews')
  return res.data.items
}

export async function fetchFreightForwarderReviews(
  ffId: string,
  opts: { page?: number; pageSize?: number; rating?: number | null } = {}
): Promise<ReviewListResponse> {
  const params: Record<string, any> = {}
  if (opts.page) params.page = opts.page
  if (opts.pageSize) params.pageSize = opts.pageSize
  if (opts.rating) params.rating = opts.rating
  const qs = new URLSearchParams(params).toString()
  const res = await api.get<ReviewListResponse>(`/freight-forwarders/${ffId}/reviews${qs ? `?${qs}` : ''}`)
  return res.data
}

export async function fetchFreightForwarderRatingSummary(ffId: string): Promise<RatingSummary> {
  const res = await api.get<RatingSummary>(`/freight-forwarders/${ffId}/rating-summary`)
  return res.data
}
